module.exports = __webpack_public_path__ + "static/media/weigh_tickets_active.daaa9408.svg";